import API from '@/api/apiCreate'
import { isError } from '@/helpers/checkQuery'
import { ResponseWrapper } from '@/api/types/base.types'
import { getApiErrorMessage, TASK_TRACKER_API_REQUEST_CONFIG } from './taskTracker.api.utils'
import { mapCrmLeadReferencesTreeFromApi } from './taskTracker.references.api.mappers'
import type { ApiTaskTrackerReferencesTreeResponse } from './taskTracker.references.api.types'
import type {
  GetTaskTrackerCrmLeadTreeParams,
  TaskTrackerCrmLeadTreePage,
} from '../lib/taskTrackerCrmLeadSticker.types'
import { TASK_TRACKER_CRM_LEAD_SYSTEM_KEY } from '../lib/taskTrackerCrmLeadSticker.utils'

const DEFAULT_TREE_LIMIT = 20
const MAX_TREE_LIMIT = 50

const buildTreeQuery = ({
  search,
  cursor,
  limit,
}: GetTaskTrackerCrmLeadTreeParams) => {
  const rawLimit = limit ?? DEFAULT_TREE_LIMIT
  const normalizedLimit = Math.min(
    Math.max(1, Math.floor(rawLimit)),
    MAX_TREE_LIMIT,
  )

  const searchParams = new URLSearchParams()
  searchParams.set('system_key', TASK_TRACKER_CRM_LEAD_SYSTEM_KEY)
  searchParams.set('limit', String(normalizedLimit))
  searchParams.set('search', search?.trim() ?? '')

  if (cursor != null && String(cursor).trim() !== '') {
    searchParams.set('cursor', String(cursor).trim())
  } else {
    searchParams.set('cursor', '0')
  }

  return `?${searchParams.toString()}`
}

export const taskTrackerReferencesApi = {
  async getCrmLeadTree(
    params: GetTaskTrackerCrmLeadTreeParams = {},
  ): Promise<TaskTrackerCrmLeadTreePage> {
    const res = await API.get<
      ResponseWrapper<ApiTaskTrackerReferencesTreeResponse>
    >(
      `task-tracker-references/tree${buildTreeQuery(params)}`,
      TASK_TRACKER_API_REQUEST_CONFIG,
    )

    if (isError(res)) {
      throw new Error(
        getApiErrorMessage(res, 'Не удалось загрузить список лидов'),
      )
    }

    return mapCrmLeadReferencesTreeFromApi(res.data?.data)
  },
}
